import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitogoacab() {



  const cardData = {




keyword: "Mumbai to Goa Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Mumbai to Goa Cab Service for families, couples, friends, corporate travelers, and groups planning a convenient long-distance road journey. Customers can book chauffeur-driven Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, and other suitable vehicles for one-way trips, round trips, weekend holidays, beach vacations, family tours, corporate travel, and customized Goa itineraries. With experienced drivers, clean and well-maintained vehicles, comfortable seating, spacious luggage areas, flexible pickup locations across Mumbai, transparent pricing, and 24/7 customer assistance, Garud Cab Service makes the long journey from Mumbai to Goa smooth and comfortable. Travelers can customize their route to explore beaches, forts, waterfalls, temples, markets, heritage sites, and scenic destinations across Goa and the Konkan region according to their preferred schedule.",

topPlaces: [
  {
    title: "North Goa",
    description: "North Goa is popular for its lively beaches, markets, historic forts, restaurants, nightlife, and variety of tourist attractions. Travelers from Mumbai can use a private cab for convenient door-to-door transportation with luggage. Garud Cab Service offers flexible one-way and round-trip options for families, couples, and groups planning a Goa holiday."
  },
  {
    title: "South Goa",
    description: "South Goa is known for peaceful beaches, scenic coastal landscapes, resorts, churches, and a more relaxed holiday atmosphere. It is suitable for families and travelers seeking a quieter Goa experience. Customers can book a comfortable chauffeur-driven cab from Mumbai and customize their journey around preferred beaches and sightseeing locations."
  },
  {
    title: "Panaji",
    description: "Panaji is the capital of Goa and is known for heritage architecture, the Mandovi River, colorful streets, churches, and cultural attractions. Travelers arriving from Mumbai can conveniently reach Panaji directly by private cab. Garud Cab Service provides comfortable vehicles with flexible pickup, drop, and sightseeing arrangements for different passenger requirements."
  },
  {
    title: "Calangute",
    description: "Calangute is one of Goa's most popular beach destinations and attracts tourists with its sandy shoreline, restaurants, shopping areas, and water activities. Families, couples, and groups can travel comfortably from Mumbai in a private cab. Customers can choose Sedan, SUV, Ertiga, Innova, or Innova Crysta according to their group size."
  },
  {
    title: "Palolem",
    description: "Palolem is a scenic beach destination in South Goa known for its beautiful coastline, peaceful surroundings, and relaxed holiday atmosphere. It is especially suitable for couples, families, and travelers looking for a quieter coastal experience. Garud Cab Service provides comfortable long-distance cab travel from Mumbai with flexible multi-day booking options."
  },
  {
    title: "Baga",
    description: "Baga is a popular North Goa destination known for its beach, restaurants, shopping, entertainment, and lively atmosphere. Travelers can conveniently reach Baga from Mumbai by private chauffeur-driven cab without changing transportation during the journey. Customers can also include nearby attractions in a customized Goa sightseeing itinerary."
  },
  {
    title: "Anjuna",
    description: "Anjuna is a well-known Goa destination famous for its beach, vibrant market culture, scenic coastline, and relaxed tourist atmosphere. It is popular among couples, friends, and international and domestic travelers. Customers traveling from Mumbai can book a private cab and customize the route to include Anjuna and nearby North Goa attractions."
  },
  {
    title: "Dudhsagar",
    description: "Dudhsagar Waterfalls is one of Goa's most famous natural attractions, surrounded by forests and the Western Ghats. Travelers often include the waterfall in an extended Goa holiday itinerary. Garud Cab Service can provide private transportation for the road portions of the journey and help customers plan a convenient multi-destination travel schedule."
  },
  {
    title: "Old Goa",
    description: "Old Goa is a major heritage destination known for historic churches, basilicas, and Portuguese-era architecture. It offers travelers a cultural and historical experience beyond Goa's beaches. Customers traveling from Mumbai can include Old Goa in their private cab itinerary along with Panaji and other nearby attractions."
  },
  {
    title: "Vagator",
    description: "Vagator is a scenic North Goa destination known for dramatic coastal landscapes, rocky viewpoints, beaches, and a relaxed holiday environment. It is suitable for couples, friends, and families exploring the northern coastline. Garud Cab Service provides comfortable Mumbai to Goa cab transportation with flexible sightseeing and return travel arrangements."
  }
],




"services": [
{
"name": "Mumbai to Goa Car Rental",
"description": "Book Mumbai to Goa Car Rental for comfortable and convenient private road transportation with professional chauffeurs and well-maintained vehicles. The service is suitable for families, couples, groups, corporate travelers, and tourists planning a long-distance journey to Goa."
},
{
"name": "Mumbai to Goa Taxi Fare",
"description": "Check Mumbai to Goa Taxi Fare according to the selected vehicle category, pickup location, journey type, and travel requirements. Sedan, SUV, Innova, premium cars, and larger vehicles can be arranged for comfortable private transportation."
},
{
"name": "Mumbai to Goa Cab Fare",
"description": "Find Mumbai to Goa Cab Fare based on vehicle type, travel schedule, pickup point, and journey requirements. Customers can choose suitable chauffeur-driven vehicles for family trips, business travel, sightseeing, and private road journeys."
},
{
"name": "Mumbai to Goa Taxi One Way Fare",
"description": "Check Mumbai to Goa Taxi One Way Fare for direct point-to-point transportation without requiring a return booking. The service is suitable for travelers relocating, visiting family, planning vacations, or traveling to Goa for business or personal requirements."
},
{
"name": "Mumbai to Goa Cab Price",
"description": "Check Mumbai to Goa Cab Price according to the selected vehicle, pickup location, travel date, and journey type. Comfortable AC cars can be arranged for individuals, families, groups, corporate passengers, and tourists traveling by road."
},
{
"name": "Mumbai to Goa by Car Fare",
"description": "Find Mumbai to Goa by Car Fare for a private chauffeur-driven road journey with convenient pickup and destination drop. Sedan, SUV, Innova, and premium vehicle options can be selected according to passenger count and luggage requirements."
},
{
"name": "Book Cab from Mumbai to Goa",
"description": "Book Cab from Mumbai to Goa for comfortable private transportation with convenient pickup arrangements across Mumbai. The service is suitable for families, couples, groups, tourists, and business travelers planning a direct road journey to Goa."
},
{
"name": "Car on Rent from Mumbai to Goa",
"description": "Choose Car on Rent from Mumbai to Goa for a convenient long-distance journey with professional chauffeur assistance. Suitable cars can be arranged for weekend vacations, family holidays, corporate travel, sightseeing, and personal road trips."
},
{
"name": "Mumbai Airport to Goa Cab",
"description": "Book Mumbai Airport to Goa Cab for direct transportation from Mumbai airport to your preferred destination in Goa. Comfortable AC vehicles with luggage space are suitable for tourists, families, corporate passengers, and travelers arriving in Mumbai."
},
{
"name": "Mumbai Goa Cab Service",
"description": "Choose Mumbai Goa Cab Service for comfortable private intercity transportation between Mumbai and Goa. Professional chauffeurs and suitable vehicle categories can be arranged for family vacations, business travel, sightseeing, weekend trips, and personal journeys."
},
{
"name": "Mumbai to Goa by Road Taxi Fare",
"description": "Check Mumbai to Goa by Road Taxi Fare according to the vehicle category, pickup location, and journey requirements. Private chauffeur-driven cars provide a convenient option for passengers planning a comfortable long-distance road trip."
},
{
"name": "Mumbai to Goa Cab Charges",
"description": "Check Mumbai to Goa Cab Charges based on the selected vehicle and overall journey requirements. Customers can choose practical sedan, spacious SUV, Innova, premium car, or larger group transportation according to their travel needs."
},
{
"name": "Mumbai to Goa Cab Booking Price",
"description": "Find Mumbai to Goa Cab Booking Price according to vehicle type, pickup location, travel schedule, and journey preferences. Advance booking allows travelers to arrange suitable chauffeur-driven transportation for their planned Goa journey."
},
{
"name": "Mumbai to Goa Cab Booking",
"description": "Make Mumbai to Goa Cab Booking for a scheduled private road journey with convenient pickup arrangements. Sedan, SUV, Innova, premium cars, and group travel options can be selected according to passenger count and luggage."
},
{
"name": "Mumbai to Goa Cab Hire",
"description": "Choose Mumbai to Goa Cab Hire for comfortable chauffeur-driven transportation over the long-distance route. The service is suitable for families, tourists, couples, corporate travelers, and groups planning a private journey to Goa."
},
{
"name": "Mumbai to Goa Cab Facility",
"description": "Book Mumbai to Goa Cab Facility for convenient private transportation with professional driver assistance and comfortable vehicles. The service can be arranged for airport pickups, family vacations, business travel, sightseeing, and long-distance road journeys."
},
{
"name": "Mumbai to Goa Cab Rates",
"description": "Check Mumbai to Goa Cab Rates according to the selected vehicle category, pickup point, travel schedule, and journey type. Sedan, SUV, Innova, luxury vehicles, and larger options can be arranged for different passenger requirements."
},
{
"name": "Mumbai to Goa Cab Service",
"description": "Choose Mumbai to Goa Cab Service for reliable private transportation with comfortable AC vehicles and professional chauffeurs. The service is suitable for families, tourists, corporate passengers, couples, and groups planning travel between Mumbai and Goa."
},
{
"name": "Mumbai to Goa Cab Service Fare",
"description": "Find Mumbai to Goa Cab Service Fare based on vehicle selection, pickup location, journey type, and travel requirements. Customers can select suitable vehicles for one-way journeys, round trips, family vacations, and corporate travel."
},
{
"name": "Mumbai to Goa Car Booking",
"description": "Book Mumbai to Goa Car Booking for a comfortable private road journey with flexible pickup arrangements. Suitable cars can be arranged for families, couples, business travelers, tourists, and groups traveling to Goa."
},
{
"name": "Mumbai to Goa Car Hire",
"description": "Choose Mumbai to Goa Car Hire for convenient chauffeur-driven transportation over the long-distance route. Sedan, SUV, Innova, and premium options can be arranged according to passenger count, luggage, comfort preferences, and travel plans."
},
{
"name": "Mumbai to Goa Car Service",
"description": "Book Mumbai to Goa Car Service for comfortable private transportation with professional chauffeur assistance. The service is suitable for weekend holidays, family trips, corporate journeys, sightseeing, beach vacations, and personal travel."
},
{
"name": "Mumbai to Goa Ola Cabs Fare",
"description": "Compare Mumbai to Goa Ola Cabs Fare with private intercity cab options based on vehicle category and journey requirements. Travelers can consider suitable chauffeur-driven cars for long-distance travel, family trips, and planned Goa vacations."
},
{
"name": "Mumbai to Goa One Way Cab",
"description": "Choose Mumbai to Goa One Way Cab for direct transportation from Mumbai to Goa without requiring a return booking. The service is suitable for tourists, families, couples, business travelers, and passengers planning a one-way road journey."
},
{
"name": "Mumbai to Goa One Way Taxi",
"description": "Book Mumbai to Goa One Way Taxi for convenient point-to-point transportation with professional chauffeur assistance. Comfortable AC vehicles can be arranged for individuals, families, couples, corporate travelers, and tourists."
},
{
"name": "Mumbai to Goa Taxi Price",
"description": "Check Mumbai to Goa Taxi Price according to vehicle category, pickup location, travel schedule, and journey requirements. Customers can select sedan, SUV, Innova, premium, or larger vehicles based on passenger and luggage needs."
},
{
"name": "Mumbai to Goa Taxi Rate",
"description": "Find Mumbai to Goa Taxi Rate according to the selected vehicle and journey type. Private chauffeur-driven transportation can be arranged for one-way travel, round trips, family vacations, business journeys, and sightseeing requirements."
},
{
"name": "Mumbai to Goa Taxi Service",
"description": "Choose Mumbai to Goa Taxi Service for comfortable and convenient intercity transportation with professional chauffeurs. The service is suitable for families, couples, tourists, corporate passengers, and groups planning a private road journey."
},
{
"name": "Taxi Service from Mumbai to Goa",
"description": "Book Taxi Service from Mumbai to Goa for direct private transportation with convenient pickup from your preferred Mumbai location. Comfortable AC vehicles are suitable for long-distance family travel, vacations, business trips, and sightseeing."
},
{
"name": "Mumbai to Goa Innova Cab",
"description": "Choose Mumbai to Goa Innova Cab for spacious and comfortable transportation suitable for families and small groups. The vehicle provides practical seating and luggage space for long-distance travel, vacations, sightseeing, and business journeys."
},
{
"name": "Mumbai to Goa Ertiga Cab",
"description": "Book Mumbai to Goa Ertiga Cab for comfortable group travel with practical seating and luggage capacity. It is suitable for families, small groups, corporate passengers, and travelers looking for convenient transportation for a Goa road trip."
},
{
"name": "Mumbai to Goa Sedan Cab",
"description": "Choose Mumbai to Goa Sedan Cab for comfortable AC transportation suitable for individuals, couples, and small families. Sedan travel provides practical seating and luggage space for business trips, holidays, personal visits, and long-distance journeys."
},
{
"name": "Mumbai to Goa SUV Taxi",
"description": "Book Mumbai to Goa SUV Taxi for spacious private transportation with additional seating and luggage capacity. SUVs are suitable for families, groups, tourists, corporate travelers, and passengers planning a comfortable long-distance road trip."
},
{
"name": "Mumbai to Goa AC Cab",
"description": "Choose Mumbai to Goa AC Cab for comfortable climate-controlled travel throughout the journey. The service is suitable for families, couples, business travelers, tourists, and groups who prefer private transportation with professional chauffeur assistance."
},
{
"name": "Mumbai to Goa Luxury Cab",
"description": "Book Mumbai to Goa Luxury Cab for premium private transportation with enhanced comfort and professional chauffeur service. It is suitable for executives, couples, corporate passengers, special occasions, and travelers seeking a more comfortable road journey."
},
{
"name": "Mumbai to Goa Tempo Traveller",
"description": "Choose Mumbai to Goa Tempo Traveller for group transportation with spacious seating and luggage capacity. It is suitable for families, friends, corporate groups, wedding groups, and larger parties planning a comfortable road trip to Goa."
},
{
"name": "Mumbai to Goa Beach Trip Cab",
"description": "Book Mumbai to Goa Beach Trip Cab for convenient private transportation during a Goa beach vacation. The service is suitable for families, couples, friends, and groups planning leisure travel, sightseeing, beach visits, and resort stays."
},
{
"name": "Mumbai to Goa Weekend Trip Taxi",
"description": "Choose Mumbai to Goa Weekend Trip Taxi for comfortable transportation during a short Goa holiday. Private chauffeur-driven cars can be arranged for couples, families, friends, and groups planning a convenient weekend road trip."
},
{
"name": "Mumbai to North Goa Cab",
"description": "Book Mumbai to North Goa Cab for direct private transportation to popular North Goa destinations. Comfortable vehicles can be arranged for tourists, families, couples, groups, and travelers planning beach holidays, sightseeing, and resort stays."
},
{
"name": "Mumbai to South Goa Cab",
"description": "Choose Mumbai to South Goa Cab for comfortable long-distance transportation to destinations across South Goa. The service is suitable for families, couples, tourists, corporate travelers, and groups looking for private road travel."
},
{
"name": "Mumbai to Goa Family Trip Cab",
"description": "Book Mumbai to Goa Family Trip Cab for spacious and comfortable transportation designed for family vacations. Suitable vehicles can accommodate passengers and luggage while providing convenient pickup, private travel, and direct destination drop."
},
{
"name": "Mumbai to Goa Corporate Travel Taxi",
"description": "Choose Mumbai to Goa Corporate Travel Taxi for professional transportation supporting business visits, meetings, corporate events, and work-related journeys. Sedan, SUV, and premium vehicles can be arranged according to corporate travel requirements."
}
],
"tableData": [
["Mumbai to Goa Car Rental", "Mumbai to Goa Taxi Fare"],
["Mumbai to Goa Cab Fare", "Mumbai to Goa Taxi One Way Fare"],
["Mumbai to Goa Cab Price", "Mumbai to Goa by Car Fare"],
["Book Cab from Mumbai to Goa", "Car on Rent from Mumbai to Goa"],
["Mumbai Airport to Goa Cab", "Mumbai Goa Cab Service"],
["Mumbai to Goa by Road Taxi Fare", "Mumbai to Goa Cab Charges"],
["Mumbai to Goa Cab Booking Price", "Mumbai to Goa Cab Booking"],
["Mumbai to Goa Cab Hire", "Mumbai to Goa Cab Facility"],
["Mumbai to Goa Cab Rates", "Mumbai to Goa Cab Service"],
["Mumbai to Goa Cab Service Fare", "Mumbai to Goa Car Booking"],
["Mumbai to Goa Car Hire", "Mumbai to Goa Car Service"],
["Mumbai to Goa Ola Cabs Fare", "Mumbai to Goa One Way Cab"],
["Mumbai to Goa One Way Taxi", "Mumbai to Goa Taxi Price"],
["Mumbai to Goa Taxi Rate", "Mumbai to Goa Taxi Service"],
["Taxi Service from Mumbai to Goa", "Mumbai to Goa Innova Cab"],
["Mumbai to Goa Ertiga Cab", "Mumbai to Goa Sedan Cab"],
["Mumbai to Goa SUV Taxi", "Mumbai to Goa AC Cab"],
["Mumbai to Goa Luxury Cab", "Mumbai to Goa Tempo Traveller"],
["Mumbai to Goa Beach Trip Cab", "Mumbai to Goa Weekend Trip Taxi"],
["Mumbai to North Goa Cab", "Mumbai to South Goa Cab"],
["Mumbai to Goa Family Trip Cab", "Mumbai to Goa Corporate Travel Taxi"]
]
,



whychoose: [
  {
    WhyChooseheading: "Mumbai to Goa Cab for a Comfortable Road Trip",
    WhyChoosedescription: "A private cab is a convenient option for travellers heading from Mumbai to Goa for holidays, beach vacations, family trips, couples' getaways, business visits, or extended road journeys along the Konkan route."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Mumbai Location",
    WhyChoosedescription: "Passengers can start their journey from a home, hotel, office, residential area, or another accessible location in Mumbai, making it easier to coordinate departure according to the travel plan."
  },
  {
    WhyChooseheading: "Comfortable Travel for Families & Groups",
    WhyChoosedescription: "Families, couples, friends, and groups can select a suitable cab based on passenger count, luggage requirements, and comfort preferences for the long-distance journey to Goa."
  },
  {
    WhyChooseheading: "Ideal for Goa Holidays & Beach Trips",
    WhyChoosedescription: "Private road transportation is suitable for travellers planning beach holidays, weekend breaks, sightseeing trips, family vacations, and leisure stays in different parts of Goa."
  },
  {
    WhyChooseheading: "Convenient for Long-Distance Travel",
    WhyChoosedescription: "Travelling by private cab provides direct point-to-point transportation from Mumbai to your selected destination in Goa without requiring passengers to change vehicles during the journey."
  },
  {
    WhyChooseheading: "One-Way Cab for Direct Goa Drop",
    WhyChoosedescription: "Passengers travelling to Goa for a holiday, hotel stay, family visit, or onward journey can choose a one-way cab when they do not require the same vehicle for the return trip."
  },
  {
    WhyChooseheading: "Round-Trip Cab for Goa Vacations",
    WhyChoosedescription: "A round-trip arrangement is useful for travellers who want to keep the same private vehicle for their Goa holiday and return journey to Mumbai after completing their planned stay."
  },
  {
    WhyChooseheading: "Easy Booking with Garud Cab Service",
    WhyChoosedescription: "Share your Mumbai pickup point, Goa destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip requirement with Garud Cab Service for booking assistance."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Mumbai to Goa Cab Service?",
    answer: "Yes, Garud Cab Service provides private Mumbai to Goa cab services for families, couples, groups, tourists, business travellers, and passengers planning leisure or personal trips."
  },
  {
    question: "Can I book a one-way cab from Mumbai to Goa?",
    answer: "Yes, one-way cab service can be arranged for passengers who need direct transportation from Mumbai to their preferred hotel, resort, residence, or destination in Goa."
  },
  {
    question: "Can I book a round-trip cab for Mumbai to Goa?",
    answer: "Yes, round-trip cab arrangements can be planned for holidays, family vacations, couples' trips, sightseeing plans, and journeys requiring transportation back to Mumbai."
  },
  {
    question: "Is Mumbai to Goa cab suitable for families?",
    answer: "Yes, private cab travel is suitable for families and groups who want to travel together with convenient seating and luggage arrangements throughout the long-distance journey."
  },
  {
    question: "Can couples book a private cab to Goa?",
    answer: "Yes, couples can arrange a private cab for Goa holidays, weekend getaways, special occasions, beach trips, and personal travel."
  },
  {
    question: "Can I travel directly to my Goa hotel?",
    answer: "Yes, the cab can provide direct transportation from Mumbai to an accessible hotel, resort, residence, or other preferred destination in Goa."
  },
  {
    question: "Can I carry luggage in the Mumbai to Goa cab?",
    answer: "Yes, passengers can carry luggage according to the available space in the selected vehicle. Larger luggage requirements should be shared during booking."
  },
  {
    question: "Can friends book a cab from Mumbai to Goa?",
    answer: "Yes, groups of friends can book a private cab for Goa holidays, road trips, sightseeing, and weekend travel while travelling together in the same vehicle."
  },
  {
    question: "Can I book a cab for a Goa road trip?",
    answer: "Yes, a private cab can be arranged for a planned road trip from Mumbai to Goa, with the vehicle selected according to passenger numbers and luggage requirements."
  },
  {
    question: "How can I book a Mumbai to Goa Cab?",
    answer: "Share your Mumbai pickup location, Goa destination, travel date, passenger details, luggage requirements, preferred vehicle, and one-way or round-trip preference with Garud Cab Service."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Sawant",
    feedback: "Our friends planned a road trip from Mumbai to Goa and selected a private cab. Travelling together made the long journey more enjoyable, especially with all our holiday luggage.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Mehta",
    feedback: "We booked a private cab for our family Goa vacation. The direct journey from Mumbai to our hotel was convenient and allowed us to travel together without changing vehicles.",
    rating: 5
  }
];








  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Goa Cab",
  "image": "https://garudcabs.com/assets/images/mumbai-to-goa-cab.webp",
  "description": "Book Mumbai to Goa Cab with Garud Cab for safe, comfortable, and reliable long-distance travel. Get Mumbai to Goa taxi, cab, car rental, and one way travel services for family trips, holidays, business journeys, and group travel. Choose Sedan, Ertiga, SUV, Innova, or Innova Crysta vehicles with convenient pickup and drop facilities and flexible travel options.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/mumbai-to-goa-cab"
  }
};





  return (
    <div>



<Helmet>
  <title>Mumbai to Goa Cab | Taxi, Car Rental & One Way Cab | +91 9970007784</title>

  <meta
    name="description"
    content="Book Mumbai to Goa Cab with Garud Cab for comfortable and reliable travel. Get one way, round trip, taxi, car rental, and holiday trip cab services with Sedan, Ertiga, SUV, Innova, and Innova Crysta options."
  />

  <meta
    name="keywords"
    content="Mumbai to Goa Car Rental, Mumbai to Goa Taxi Fare, Mumbai to Goa Cab Fare, Mumbai to Goa Taxi One Way Fare, Mumbai to Goa Cab Price, Mumbai to Goa by Car Fare, Book Cab from Mumbai to Goa, Car on Rent from Mumbai to Goa, Mumbai to Goa Cab, Mumbai to Goa Taxi, Mumbai to Goa Cab Service, Mumbai to Goa One Way Cab, Mumbai to Goa Car Hire, Mumbai to Goa Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/102.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitogoacab;